// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import styles from './cards.module.less';

interface i_card_props {
  image: string;
  description: string;
  link: string;
  link_text: string;
}

interface i_cards_props {
  title: string;
  cards: i_card_props[];
}

const Card = ({image, description, link, link_text}: i_card_props)=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.card}>
    <div className={styles.card_image}>
      <img src={image} alt="image" className="lazyload"/>
    </div>
    <p className={cn(theme.p2, theme.reg, theme.color_n700,
      styles.card_description)}
      dangerouslySetInnerHTML={{__html: description}}></p>
    <Button to={link} caption={link_text} color="transparent"
      cls={styles.card_btn}/>
  </div>;
};

export const Cards = (props: i_cards_props)=>{
  const {theme} = useContext(Settings_context);
  return <div className={styles.cards_container}>
    <p className={cn(theme.H3, styles.cards_title)}>{props.title}</p>
    <div className={styles.cards}>
      {Array.isArray(props.cards) && props.cards.map((f, i)=>
        <Fragment key={i}><Card {...f}/></Fragment>)}
    </div>
  </div>;
};

interface i_cards_editor_props {
  value: i_cards_props;
  on_change: (new_value: i_cards_props)=>void;
  on_cancel: ()=>void;
}

export const Cards_editor = (props: i_cards_editor_props)=>{
  const [state, set_state] = useState<i_cards_props>(()=>({
    title: props.value?.title ?? '',
    cards: props.value?.cards ?? [],
  }));
  const cards = state.cards || [];
  const desc_label = 'Description (wrap words into <strong>word</strong>'
    +' if you need bold words';
  useEffect(()=>{
      set_state(c=>({...c, ...props.value}));
  }, [props.value]);
  return <Editor
    title={'Cards'}
    value={state}
    editors={[{key: 'title', label: 'Title', type: 'textarea'}]}
    on_change={v=>set_state(v)}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}>
    <h4>Cards: </h4>
    {cards.map((li, i)=>
      <Fragment key={i}>
        <Editor
          title={li.description || `unknown`}
          key={i}
          value={li}
          editors={[
            {key: 'image', label: 'Image', type: 'text'},
            {key: 'description', label: desc_label, type: 'textarea'},
            {key: 'link', label: 'Url', type: 'text'},
            {key: 'link_text', label: 'Url Text', type: 'text'},
          ]}
          on_change={v=>{
            const items_new = [...cards];
            items_new[i] = v;
            set_state({...state, cards: items_new});
          }}>
        </Editor>
        <Button caption={'Delete Card'} size={'xs'}
          on_click={()=>{
            set_state({...state, cards: cards
              .filter((_, index)=>index!==i)});
          }}/>
      </Fragment>
    )}
    <Button caption={'Add Card'} size={'xs'}
      on_click={()=>{
        set_state({...state, cards: [...cards, {
          description: '',
          link: '',
          link_text: '',
          image: '',
        }]});
      }}/>
  </Editor>;
};
